module.exports = __webpack_public_path__ + "img/crafted-grey.6a838542.svg";